import { configureStore } from '@reduxjs/toolkit'
import React from 'react';
import SkipReducer from './SkipToMainContentSlice';
import ThemeReducer from './ThemeSlice';
import FontReducer from './FontSlice';

const SkipToMainContentStore =configureStore({
    reducer:{
        skip:SkipReducer,
        theme:ThemeReducer,
        font: FontReducer
    }
})

export default SkipToMainContentStore